export default function HeroSection() {
  const stats = [
    { value: '2000+', label: '部剧集资源' },
    { value: '每日更新', label: '最新剧集同步' },
    { value: '1080P', label: '高清画质' },
  ];

  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20atmosphere%20with%20abstract%20geometric%20patterns%20in%20deep%20crimson%20and%20charcoal%20tones%2C%20subtle%20film%20grain%20texture%2C%20dramatic%20lighting%20with%20warm%20accents%2C%20modern%20streaming%20platform%20aesthetic%2C%20no%20text%2C%20no%20people%2C%20atmospheric%20and%20elegant%20dark%20background%20with%20flowing%20gradients&width=1920&height=1080&seq=hero-bg-2026-x1&orientation=landscape"
          alt="红桃影视背景"
          className="w-full h-full object-cover object-top opacity-40"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-50/60 via-background-50/40 to-background-50"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-24 md:py-32">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
            <div className="flex-1 w-full text-center lg:text-left">
              <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-500/15 border border-primary-500/25 mb-6">
                <span className="w-2 h-2 rounded-full bg-accent-500 animate-pulse"></span>
                <span className="text-xs font-medium text-primary-400 whitespace-nowrap">今日更新 12 部热门剧集</span>
              </div>

              <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-foreground-950 font-heading leading-tight">
                红桃影视
                <span className="block text-primary-400 mt-2">热门剧集高清在线观看平台</span>
              </h1>

              <p className="mt-5 md:mt-6 text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0">
                红桃影视电视剧频道收录海量全集资源，热门剧集、最新大陆剧韩剧持续更新。无论是热播国产大剧、高分韩剧还是经典港台剧集，这里都有高清完整版。每日同步更新，追剧不等待，随时随地畅享流畅观影体验。
              </p>

              <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-8 mt-7 md:mt-8">
                {stats.map((stat) => (
                  <div key={stat.label} className="text-center">
                    <div className="text-xl md:text-2xl font-bold text-foreground-950 font-heading">{stat.value}</div>
                    <div className="text-xs text-foreground-500 mt-1">{stat.label}</div>
                  </div>
                ))}
              </div>

              <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3 mt-8">
                <a
                  href="#ranking"
                  className="w-full sm:w-auto px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer text-sm"
                >
                  <i className="ri-fire-line mr-2"></i>查看热门排行榜
                </a>
                <a
                  href="#carousel"
                  className="w-full sm:w-auto px-6 py-3 bg-background-100 hover:bg-background-200 text-foreground-700 font-medium rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer text-sm border border-background-200/60"
                >
                  <i className="ri-star-line mr-2"></i>精选推荐剧集
                </a>
              </div>
            </div>

            <div className="flex-1 w-full max-w-lg lg:max-w-none">
              <div className="relative">
                <div className="absolute -inset-1 bg-gradient-to-r from-primary-500/20 via-accent-500/10 to-primary-500/20 rounded-2xl blur-xl"></div>
                <div className="relative bg-background-100/80 backdrop-blur-sm border border-background-200/40 rounded-2xl overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20collage%20featuring%20dramatic%20Chinese%20TV%20drama%20and%20Korean%20drama%20scenes%2C%20warm%20lighting%2C%20emotional%20expressions%2C%20modern%20costume%20drama%20and%20contemporary%20romance%20themes%2C%20artistic%20composition%20with%20cinematic%20color%20grading%2C%20film%20texture%2C%20elegant%20dark%20backdrop&width=800&height=600&seq=hero-main-2026-x1&orientation=landscape"
                    alt="红桃影视热门剧集主视觉展示"
                    className="w-full h-auto object-cover"
                  />
                </div>
                <div className="absolute -bottom-3 -right-3 bg-background-50 border border-background-200/60 rounded-xl px-4 py-2.5 shadow-sm">
                  <div className="flex items-center gap-2">
                    <span className="w-2 h-2 rounded-full bg-accent-500"></span>
                    <span className="text-xs text-foreground-600 whitespace-nowrap">实时更新中</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}